import Loader from 'apollo-react/components/Loader';
import MenuItem from 'apollo-react/components/MenuItem';
import Paper from 'apollo-react/components/Paper';
import React from 'react';
import Select from 'apollo-react/components/Select';

const AvailableFeatures = ({
  intl,
  classes,
  change,
  activityType,
  isLoading,
  isActivityTypeLoading,
  activityTypes,
  status,
}) => {
  if (isLoading || isActivityTypeLoading) {
    return <Loader />;
  }

  return (
    activityTypes && (
      <Paper className={classes.main} elevation={2}>
        <Select
          name="activityType"
          label={intl.formatMessage({ id: 'journeyBuilder.activityTypes' })}
          value={activityType}
          fullWidth
          canDeselect={false}
          onChange={e => {
            change('activityType', e.target.value);
          }}
          disabled={status}
          multiple
          required
        >
          {activityTypes.map(x => (
            <MenuItem key={x.name} value={x.name}>
              {intl.formatMessage({ id: `journeyBuilder.${x.name}` })}
            </MenuItem>
          ))}
        </Select>
      </Paper>
    )
  );
};

AvailableFeatures.displayName = 'AvailableFeatures';

export default AvailableFeatures;



// WEBPACK FOOTER //
// ./src/JourneyBuilder/SendOptimizer/components/AvailableFeatures/AvailableFeatures.js